export default function Footer() {
  return (
    <footer className="py-6 bg-darkbg text-center text-gray-400">
      &copy; 2025 Deepika D. All rights reserved.
    </footer>
  );
}
